import { DragBox } from '../DragBox'
import styles from './styles.module.scss'

export default function Asset({image,name}) {
    return (

        <DragBox type={'asset'} style={{transform:'scale(.7)'}} name={name}>
            <div className={styles.card}>
                <img src={image} alt={name} />
                <p>{name}</p>
            </div>
        </DragBox>
        
    )
}